import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { setShowImageDetails as setShowImageDetailsAction } from '../../slice/ImageAssetSlice';
import { writeShowImageDetails } from '../../slice/imageDetailsPreference';

/**
 * DV-2856: the "Show Image Details" toggle, shared by the Photos and Virtual
 * Staging kebabs.
 *
 * The localStorage write-back lives here rather than in the reducer for two
 * reasons: reducers stay pure, and the two call sites can't each forget to
 * persist. The slice is still the single source of truth for the flag's
 * current value — storage is only its serialization.
 */
export function useImageDetailsToggle() {
  const dispatch = useDispatch();
  const showImageDetails = useSelector(
    (state: RootState) => state.imageAsset.showImageDetails
  );

  const setShowImageDetails = (next: boolean) => {
    dispatch(setShowImageDetailsAction(next));
    writeShowImageDetails(next);
  };

  return { showImageDetails, setShowImageDetails };
}
